import { render, staticRenderFns } from "./WebhooksPage.vue?vue&type=template&id=2e061026&scoped=true"
import script from "./WebhooksPage.vue?vue&type=script&lang=js"
export * from "./WebhooksPage.vue?vue&type=script&lang=js"
import style0 from "./WebhooksPage.vue?vue&type=style&index=0&id=2e061026&prod&scoped=true&lang=css"
import style1 from "./WebhooksPage.vue?vue&type=style&index=1&id=2e061026&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e061026",
  null
  
)

export default component.exports